// My本棚に追加ボタンの機能
document.addEventListener('DOMContentLoaded', function () {
  // 全てのadd-to-mybookボタンを取得
  const addMybookButtons = document.querySelectorAll('.add-to-mybook');

  // ボタンが存在しない場合は処理を終了
  if (addMybookButtons.length === 0) {

    return;
  }

  const apiEndpoint = '/apps/rudolph/my-bookshelf/bookshelf';

  // 各ボタンに対して処理を実行
  addMybookButtons.forEach(button => {
    const hontoUserId = button.dataset.hontoUserId;
    const currentIsbn = button.dataset.productHandle;

    // honto_user_idがない場合（ログインしていない場合）はログインページへリダイレクト
    if (!hontoUserId) {

      button.onclick = function () {
        window.location.href = '/account/login';
      };
      return;
    }

    // ISBNがない場合の処理
    if (!currentIsbn) {

      return;
    }

    // My本棚ページへの遷移処理
    function redirectToMyShelf() {
      window.location.href = '/pages/my-shelf';
    }

    // 登録済み状態にする処理
    function setRegisteredState(button) {
      const btnText = button.querySelector('.mybook_btn-txt');
      if (btnText) {
        btnText.textContent = 'My本棚追加済み';
      }
      // クリックでMy本棚ページへ遷移するように設定
      button.onclick = redirectToMyShelf;
    }

    // 全ページのデータを取得して処理を実行
    getAllRegisteredIsbns().catch(error => {
      console.error('My本棚データ取得エラー:', error);
    });

    // 全ページのデータを取得する関数
    async function getAllRegisteredIsbns() {
      let allIsbns = [];
      let currentPage = 1;

      try {
        // 最初のページを取得して総ページ数を確認
        const firstResponse = await fetch(`${apiEndpoint}?honto_user_id=${hontoUserId}&page=${currentPage}&view_type=all`, {
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const firstData = await firstResponse.json();

        allIsbns = [...firstData.data.map(item => item.isbn)];

        // 残りのページがあれば取得
        const totalPages = firstData.pagination.total_pages;

        // 2ページ目以降を取得
        for (let page = 2; page <= totalPages; page++) {

          const response = await fetch(`${apiEndpoint}?honto_user_id=${hontoUserId}&page=${page}&sort=created_at_desc`, {
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
          const data = await response.json();
          allIsbns = [...allIsbns, ...data.data.map(item => item.isbn)];
        }

        // 現在の商品が登録済みかチェック
        const isRegistered = allIsbns.includes(currentIsbn);


        if (isRegistered) {

          setRegisteredState(button);
        } else {

          // 未登録の場合は、登録処理用のクリックイベントを設定
          button.onclick = async function () {
            const btnText = button.querySelector('.mybook_btn-txt');
            if (btnText) {
              btnText.textContent = '追加中...';
            }

            // title, category_code, category_name, author_nameを取得してコンソールログに出力
            const title = document.querySelector('h1')?.textContent?.trim() || '';
            const categoryLinkElement = document.querySelector('#product-genre span a');
            const categoryName = categoryLinkElement?.textContent?.trim() || '';

            // 著者名を取得
            const authorNameElement = document.querySelector('.product__author_name');
            const authorName = authorNameElement?.textContent?.trim() || '';

            let categoryCode = '';
            try {
              const apiDetailUrl = `https://junkudo.search.zetacx.net/api/search/item/detail?access_key=ty7VA*mT4ovvZhTsQPtMxo2G2QoKLx-C&isbn=${currentIsbn}`;
              const apiResponse = await fetch(apiDetailUrl);
              const apiData = await apiResponse.json();

              if (apiData.status === "0000" && apiData.product_list.length > 0) {
                categoryCode = apiData.product_list[0].genre_list.genre_code || '';
              }
            } catch (error) {
              console.error('カテゴリーコード取得エラー:', error);
            }


            // 送信するデータ（基本フィールドのみ - データベーススキーマ修正後に全フィールド版に切り替え）
            const requestData = {
              honto_user_id: hontoUserId,
              isbn: currentIsbn,
              reading_status: 0
            };

            if (categoryCode) {
              requestData.category_code = categoryCode;
            }
            if (categoryName) {
              requestData.category_name = categoryName;
            }
            if (title) {
              requestData.title = title;
            }
            if (authorName) {
              requestData.author_name = authorName;
            }


            // 全フィールド版（データベーススキーマ修正後に有効化）
            /*
            const requestData = {
              honto_user_id: hontoUserId,
              isbn: currentIsbn,
              category_code: categoryCode || undefined,
              category_name: categoryName || undefined,
              title: title || undefined,
              author_name: authorName || undefined,
              reading_status: 0
            };
            */


            const validationErrors = [];

            if (!requestData.honto_user_id || requestData.honto_user_id.trim() === '') {
              validationErrors.push('honto_user_idが空です');
            }

            if (!requestData.isbn || requestData.isbn.trim() === '') {
              validationErrors.push('isbnが空です');
            }

            if (typeof requestData.reading_status !== 'number') {
              validationErrors.push('reading_statusが数値ではありません');
            }

            if (validationErrors.length > 0) {
              console.error('バリデーションエラー:', validationErrors);
              throw new Error(`データ検証エラー: ${validationErrors.join(', ')}`);
            }

            try {


              const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(requestData)
              });

              // 500エラーの場合は特別な処理
              // if (response.status === 500) {
              //   console.error('=== 500エラー詳細 ===');
              //   console.error('サーバー側でエラーが発生しています');
              //   console.error('リクエストURL:', apiEndpoint);
              //   console.error('リクエストメソッド:', 'POST');
              //   console.error('リクエストヘッダー:', {
              //     'Content-Type': 'application/json',
              //     'Accept': 'application/json',
              //     'X-Requested-With': 'XMLHttpRequest'
              //   });
              // }

              // レスポンスボディを取得
              const responseText = await response.text();
              // console.log('Response Body (raw):', responseText);

              // JSONパースを試行
              let responseData;
              try {
                responseData = JSON.parse(responseText);

              } catch (parseError) {
                // console.log('JSON parse error:', parseError);
                // console.log('Response is not valid JSON');
              }

              if (response.status === 409) {
                alert('この本は既にMy本棚に追加されています。');
                setRegisteredState(button);
                return;
              }

              if (!response.ok) {
                // バックエンドからのエラーメッセージを表示
                let errorMessage = `登録に失敗しました (HTTP ${response.status})`;
                if (responseData && responseData.error) {
                  errorMessage = responseData.error.message || errorMessage;
                  // console.error('バックエンドエラー詳細:', responseData.error);
                } else if (responseData) {
                  console.error('レスポンスデータ:', responseData);
                }
                // console.error('HTTP Status:', response.status, response.statusText);
                // console.error('Response Headers:', Object.fromEntries(response.headers.entries()));

                // APIパラメータの情報を含むエラーメッセージを作成
                const apiParams = {
                  method: 'POST',
                  url: apiEndpoint,
                  requestData: requestData
                };

                const detailedErrorMessage = `${errorMessage}\n\nAPIパラメータ:\n${JSON.stringify(apiParams, null, 2)}\n\nURL: ${apiEndpoint}\n\nステータス: ${response.status} ${response.statusText}`;
                throw new Error(detailedErrorMessage);
              }

              setRegisteredState(button);


            } catch (error) {

              // エラーの種類に応じたメッセージ
              let userMessage = 'My本棚への追加に失敗しました';
              if (error.name === 'TypeError' && error.message.includes('fetch')) {
                userMessage = 'ネットワークエラーが発生しました。インターネット接続を確認してください。';
              } else if (error.message) {
                userMessage = `My本棚への追加に失敗しました: ${error.message}`;
              }

              if (btnText) {
                btnText.textContent = 'My本棚に追加';
              }
              alert(userMessage);
            }
          };
        }
      } catch (error) {
        //console.error('My本棚データ取得エラー:', error);
        throw error;
      }
    }
  });
});